import HttpClient from "../helpers/HttpClient"
import EcommerceConfiguration, {
    EcommerceConfigurationValueDto,
    CreateEcommerceConfigurationDto
} from "./EcommerceConfigurationValues"
import QuoteFormConfiguration from "./EcommerceQuoteFormConfiguration"
import { HttpError, isError } from "../helpers/Error"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

class EcommerceConfigurationService {
    static httpClient: HttpClient<EcommerceConfiguration,
        EcommerceConfigurationValueDto> = new HttpClient<EcommerceConfiguration,
        EcommerceConfigurationValueDto>(EcommerceConfiguration)

    static async UpdateEcommerceConfiguration(
        integrationKey: string,
        accountID: string,
        payload: CreateEcommerceConfigurationDto,
    ) {
        return this.httpClient.patch(`/ecommerce-configuration/${integrationKey}/${[accountID]}`, payload)
    }

    static async GetEcommerceConfiguration(
        integrationKey: string,
        accountID: string
    ): Promise<EcommerceConfiguration | HttpError> {
        const res = await this.httpClient.get(`/ecommerce-configuration/${integrationKey}/${accountID}`)
        if (!isError(res)) {
            return res as EcommerceConfiguration
        }
        return res as HttpError
    }

    static async GetQuoteFormConfiguration(integrationKey: string, accountID: string): Promise<QuoteFormConfiguration[]> {
        const res = await AppContext.getApiClient()
            .get(`/ecommerce-configuration/${integrationKey}/form-configurations/${accountID}`)
        if (!isError(res)) {
            return res as QuoteFormConfiguration[]
        }
        return []
    }
}

export default EcommerceConfigurationService


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceConfigurationService.ts